import { Integration } from '../../types';

export const { GOOGLE_SERVICE, MICROSOFT_SERVICE, PLATFORM_SLACK_SERVICE } = Integration;

export const WINDOW_WIDTH = 480;
export const WINDOW_HEIGHT = 924;

export const MAX_USERS = 10;

// marketplace urls to take the user to if they do not have any connected slack workspaces
export const JIRA_SLACK_URL =
	'https://marketplace.atlassian.com/apps/1216863/jira-cloud-for-slack-official';
export const CONFLUENCE_SLACK_URL =
	'https://marketplace.atlassian.com/apps/1219518/confluence-cloud-for-slack-official';

export const EXPERIMENT_PRODUCTS = ['jira', 'confluence'];

export const GOOGLE_MAIL_DOMAINS = ['gmail.com', 'googlemail.com'];

export const FETCH_INTEGRATIONS_FAILURE_MESSAGE = 'Status: Failed fetching integrations.';

export enum ThirdPartySource {
	SLACK_SOURCE = 'slack',
}

export const { SLACK_SOURCE } = ThirdPartySource;
